import withAemIntegration from "../../../withAemIntegration";
import serviceParser, { dealerDataMap } from "../../../utils/serviceParser";

import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/DealerTitle")
);

const DealerTitleEditConfig = {
  emptyLabel: "DealerTitle",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  return {
    heading: serviceParser(props.heading, dealerDataMap),
    textColor: props.headingColor,
    eliteStatus: window.LEXUS.dealerData.eliteStatus,
    monogramStatus: window.LEXUS.dealerData.dealerPrograms.find(element => element.code==="MST-C"),
    eliteDealerIcon: props.eliteDealerIcon,
    monogramData: props.monogramModel
  };
};

const DealerTitle = (props) => {
  const data = transformData(props);

  return <Component {...data} />;
};
export default withAemIntegration(
  "lexus/components/dealer-details/dealer-title"
)(DealerTitle, DealerTitleEditConfig);
